import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db45a9c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_upload_applicant",
  ref: "uploadApplicantModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  backdrop: "static",
  keyboard: "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_customer_header"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Upload File", -1))
const _hoisted_6 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body pb-10 pt-0 px-lg-17" }
const _hoisted_9 = { class: "my-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Guide", -1))
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "First row is reserved for column headers", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("ul", _hoisted_11, [
              _hoisted_12,
              (_ctx.helpText)
                ? (_openBlock(), _createElementBlock("li", _hoisted_13, _toDisplayString(_ctx.helpText), 1))
                : _createCommentVNode("", true),
              (_ctx.criticalText)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, _toDisplayString(_ctx.criticalText), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.exampleSheetUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "mt-4 d-block",
                href: _ctx.exampleSheetUrl,
                target: "_blank"
              }, "View example sheet", 8, _hoisted_15))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}